import { render } from "./DocumentsFolderView.vue?vue&type=template&id=58dfafd7&scoped=true"
import script from "./DocumentsFolderView.vue?vue&type=script&lang=js"
export * from "./DocumentsFolderView.vue?vue&type=script&lang=js"

import "./DocumentsFolderView.vue?vue&type=style&index=0&id=58dfafd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dfafd7"]])

export default __exports__